import {Container} from "@mui/material";
import type {ReactNode} from "react";

const HomePage = (): ReactNode => {
    return <Container>Welcome Home!</Container>;
};

export default HomePage;
